const failedSession = (error) => {
	const {response} = error;
	if (response && response.data.errorType === 'failedSessionMatching') {
		window.location.replace('/login')
	}
};

export default failedSession
